import { z } from "zod";

export const gatekeeperQuestionOptionSchema = z.object({
  label: z.string().min(1),
  description: z.string().nullable(),
});

export const gatekeeperQuestionSchema = z.object({
  question: z.string().min(1),
  options: z.array(gatekeeperQuestionOptionSchema).min(2).max(4),
  multiSelect: z.boolean(),
});

export const gatekeeperUserQuestionAnswerSchema = z.object({
  selectedOptions: z.array(z.number().int().min(0)),
  customResponse: z.string().optional(),
});

export const gatekeeperPrecisionPayloadSchema = z.object({
  questions: z.array(gatekeeperQuestionSchema).min(1).max(2),
  answers: z.array(gatekeeperUserQuestionAnswerSchema).min(1).max(2),
});

export const gatekeeperStructuredReplySchema = gatekeeperPrecisionPayloadSchema;

export type GatekeeperQuestionOption = z.infer<
  typeof gatekeeperQuestionOptionSchema
>;
export type GatekeeperQuestion = z.infer<typeof gatekeeperQuestionSchema>;
export type GatekeeperUserQuestionAnswer = z.infer<
  typeof gatekeeperUserQuestionAnswerSchema
>;
export type GatekeeperPrecisionPayload = z.infer<
  typeof gatekeeperPrecisionPayloadSchema
>;
